var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 28.3334C22.3641 28.3334 28.3337 22.3638 28.3337 15C28.3337 7.63622 22.3641 1.66669 15.0003 1.66669C7.63653 1.66669 1.66699 7.63622 1.66699 15C1.66699 22.3638 7.63653 28.3334 15.0003 28.3334Z",
    fill: "#FFFBDB",
    stroke: "#DFAD03",
    strokeOpacity: 0.99,
    strokeWidth: 2.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.334 19.6667L19.6673 10.3334",
    stroke: "#DFAD03",
    strokeOpacity: 0.99,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 11.6667L10.334 10.3334",
    stroke: "#DFAD03",
    strokeOpacity: 0.99,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6673 19.6667L18.334 18.3334",
    stroke: "#DFAD03",
    strokeOpacity: 0.99,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkIcon);
export default __webpack_public_path__ + "static/media/ParkIcon.13ed400d65fbf70df933b1ce291a8d5a.svg";
export { ForwardRef as ReactComponent };